module.exports = __webpack_public_path__ + "static/img/IMG_20170525_123827.3ed5aeaf.jpg";